import { EducationLevelEnum } from '@lib/utils';
import { RocModelHelper } from '../../models';
import { RocModelService } from '../services';

import { RocModelProps } from './roc-model';

export type RocModelSelfValidationBusinessRuleType = (rocModelProps: RocModelProps) => RocModelProps;

export class RocModelBusinessRules {
  private static rocModelSelfValidationBusinessRules: RocModelSelfValidationBusinessRuleType[] = [
    RocModelBusinessRules.updateDefaultNameToInstitutionName,
    RocModelBusinessRules.clearDegreeProgramIfDegreeLevelHighSchool,
    RocModelBusinessRules.updateYearsToCompleteDegreeIfNull
  ];

  public static runAllSelfValidationRules(rocModelProps: RocModelProps): RocModelProps {
    if (rocModelProps != null) {
      this.rocModelSelfValidationBusinessRules.forEach(rule => {
        rocModelProps = rule(rocModelProps);
      });
    }

    return rocModelProps;
  }

  //#region ROC MODEL BUSINESS RULES - SELF-VALIDATION

  /**
   * If the model name is still the default by the time a school is chosen, set the school name as the model name.
   */
  private static updateDefaultNameToInstitutionName(rocModelProps: RocModelProps): RocModelProps {
    if (
      rocModelProps &&
      rocModelProps?.name.startsWith(RocModelHelper.defaults.name) &&
      rocModelProps?.institutionModel
    ) {
      rocModelProps.name = rocModelProps?.institutionModel.name;
    }

    return rocModelProps;
  }

  /**
   * If the incoming degree level is high school on the rocModel, then reset the degree program value.
   */
  private static clearDegreeProgramIfDegreeLevelHighSchool(rocModelProps: RocModelProps): RocModelProps {
    if (rocModelProps && rocModelProps?.degreeLevel === EducationLevelEnum.HighSchoolDiploma) {
      rocModelProps.degreeProgram = RocModelHelper.defaults.degreeProgram;
    }

    return rocModelProps;
  }

  /**
   * If the yearsToCompleteDegree is null, set to median years of study with fallback to default value.
   */
  private static updateYearsToCompleteDegreeIfNull(rocModelProps: RocModelProps): RocModelProps {
    if (rocModelProps && rocModelProps?.yearsToCompleteDegree == null) {
      const currentInstitution = rocModelProps?.institutionModel;

      if (currentInstitution && rocModelProps?.isFulltime != null && rocModelProps?.degreeLevel) {
        const medianYearsOfStudy = RocModelService.getMedianYearsOfStudyInfo(
          currentInstitution,
          rocModelProps?.isFulltime,
          rocModelProps?.degreeLevel
        );
        rocModelProps.yearsToCompleteDegree = medianYearsOfStudy.years;
      } else {
        rocModelProps.yearsToCompleteDegree = RocModelHelper.defaults.yearsToCompleteDegree;
      }
    }

    return rocModelProps;
  }

  //#endregion
}
